// extracted by mini-css-extract-plugin
export default {"container":"red_2tO3u"};